import { render } from "./VodDemo.vue?vue&type=template&id=5042d666"
import script from "./VodDemo.vue?vue&type=script&lang=js"
export * from "./VodDemo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__